module.exports = __webpack_public_path__ + "img/taoyuan.ffcfeb20.jpg";